import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table.js'

/**
 * new column icon map for material symbols
 * @see {@link https://fonts.google.com/icons}
 */
export const ColumnIconMap: Record<ColumnTypes, string> = {
  [ColumnTypes.Address]: 'personal_places',
  [ColumnTypes.AISEO]: 'auto_mode',
  [ColumnTypes.AITextProcessing]: 'auto_mode',
  [ColumnTypes.Array]: 'data_array',
  [ColumnTypes.Attachment]: 'attach_file',
  [ColumnTypes.Barcode]: 'barcode',
  [ColumnTypes.Boolean]: 'check_box',
  [ColumnTypes.Color]: 'color_lens',
  [ColumnTypes.Connection]: 'linked_services',
  [ColumnTypes.Coordinate]: 'my_location',
  [ColumnTypes.DateTime]: 'event',
  [ColumnTypes.Email]: 'alternate_email',
  [ColumnTypes.Emoji]: 'emoji_emotions',
  [ColumnTypes.Formula]: 'functions',
  [ColumnTypes.Function]: 'function',
  [ColumnTypes.Icon]: 'emoji_symbols',
  [ColumnTypes.Image]: 'image',
  [ColumnTypes.ImageArray]: 'gallery_thumbnail',
  [ColumnTypes.Join]: 'join_left',
  [ColumnTypes.Lookup]: 'frame_inspect',
  [ColumnTypes.Math]: 'calculate',
  [ColumnTypes.MultiSelect]: 'select_check_box',
  [ColumnTypes.Number]: 'numbers',
  [ColumnTypes.Phone]: 'call',
  [ColumnTypes.QRCode]: 'qr_code',
  [ColumnTypes.Rating]: 'star_rate',
  [ColumnTypes.RichText]: 'format_quote',
  [ColumnTypes.RowID]: 'key',
  [ColumnTypes.SingleCell]: 'move_selection_left',
  [ColumnTypes.Slug]: 'link',
  [ColumnTypes.Template]: 'table_convert',
  [ColumnTypes.Text]: 'title',
  [ColumnTypes.URL]: 'link',
  [ColumnTypes.SessionID]: 'key',
}
